import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { collectionSchemaObject } from '../collectionSchema';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'

export function CollectionCatogoryAddEdit(props) {

    const { data, edit } = props.location
    const [groups, setGroups] = useState()
    const [title, setTitle] = useState("Add Collection")
    const [buttonName, setButtonName] = useState("Save")
    const [isChanged, setIsChanged] = useState(0)
    const [collectionCategory, setCollectionCatogory] = useState({
        productID: 0,
        collectionCategoryCode: '',
        collectionCategoryName: '',
        isActive: true,
        
    });
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });

    const [products, setProduct] = useState();

    
    const schema = Joi.object(collectionSchemaObject).options({ allowUnknown: true });

    useEffect(() => {
        if (data && edit) {
            setTitle("Edit Collection Category")
            setCollectionCatogory(data)
            setButtonName("Update")
        } else {
            setTitle("Add Collection Category")
        }
    }, [])

    useEffect(() => {
        trackPromise(       
            getAllProduct()
            )
    }, [])

    useEffect(() => {
        setIsChanged(isChanged + 1);
    }, [collectionCategory]);


    async function getAllProduct() {
        
        var data = await services.getCollectionProduct()
        setProduct(data)
    }


    function handleChange(e) {
        const target = e.target;

        if (target.name === "collectionCategoryCode") {
            if (target.value.length === 4) return false
        }

        const value = target.name === 'isActive' ? target.checked : target.value;

        const error = { ...errors }
        const errorMessage = validateProperty(target, collectionSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]


        setCollectionCatogory({
            ...collectionCategory,
            [e.target.name]: value
        })
        setErrors(error)
    }

    async function handleSave(e) {
        e.preventDefault()

        if (!edit) {
            const response = await services.saveCollection(collectionCategory)
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
            afterSuccessfulyChanged(response.statusCode)
        }
        else if(edit) {
            const response = await services.editData(collectionCategory)
            setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
            afterSuccessfulyChanged(response.statusCode)
        }
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/CollectionCategoryMaster' })
            }, 1500);
        }
    }

    function onCancelClick() {
        clearState();
        setErrors({});
    }

    function clearState() {
        setCollectionCatogory({
            ...collectionCategory,
            productID: 0,
            collectionCategoryCode: '',
            collectionCategoryName: '',
            isActive: true,
        })
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function generateDropDownMenu(data) {

        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<option key={key} value={key}>{value}</option>)
            }
        }
        return items
    }

    return (
        <div>
            <Fragment>
                <LoadingSpinerComponent />
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <PageHeader
                                title={title}
                                isButtonEnable={true}
                                buttonText="Back to Listing"
                                path="/CollectionCategoryMaster"
                                isChanged={isChanged}
                            />

                            <form onSubmit={(e) => handleSave(e)}>
                                <div className="card-body">


                                    <div className="form-group row">
                                        <div className="col-md pb-1">

                                            <TextField fullWidth label="Collection Category Code"
                                                name="collectionCategoryCode"
                                                id="collectionCategoryCode"
                                                value={collectionCategory.collectionCategoryCode}
                                                type="number"
                                                maxLength="3"
                                                onChange={(e) => handleChange(e)} />
                                            {errors["collectionCategoryCode"] && <span id="errbranchCode" className="text text-danger">{errors["collectionCategoryCode"]}</span>}

                                        </div>
                                        <div className="col-md pb-1">

                                            <TextField fullWidth label="Collection Category Name"
                                                name="collectionCategoryName"
                                                id="collectionCategoryName"
                                                value={collectionCategory.collectionCategoryName}
                                                type="text"
                                                onChange={(e) => handleChange(e)} />
                                            {errors["collectionCategoryName"] && <span id="errbranchCode" className="text text-danger">{errors["collectionCategoryName"]}</span>}
                                        </div>
                                        <div className="col-md">

                                            <TextField select fullWidth
                                                label="product*"
                                                id="productID"
                                                name="productID"
                                                
                                                value={collectionCategory.productID}
                                                onChange={(e) => handleChange(e)}>
                                                <option value="0">--Select Product ID--</option>
                                                {generateDropDownMenu(products)}
                                            </TextField>
                                            {errors["groupID"] && <span id="productID" className="text text-danger">{errors["productID"]}</span>}
                                        </div>
                                    </div>                                
                                    <label>Active</label>
                                    <div className="form-group row">
                                        <div className="col-md ">
                                            <input
                                                id="isActive"
                                                switch="none"
                                                className="mr-2"
                                                type="checkbox"
                                                name="isActive"
                                                onChange={(e) => handleChange(e)}
                                                checked={collectionCategory.isActive}
                                            />
                                            <label htmlFor="isActive" data-on-label="Yes"
                                                data-off-label="No"></label>
                                        </div>
                                    </div>
                                    

                                </div>
                                <div className="card-footer">
                                        <input
                                        disabled={validate(schema, collectionCategory)}
                                            type="submit"
                                            className="btn btn-primary"
                                            value={buttonName}
                                        />
                                        <input
                                            type="button"
                                            className="btn btn-warning pull-right"
                                            value="Clear"
                                            onClick={onCancelClick}
                                        />

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <MessageModal
                    hidden={messageModel.hidden}
                    messageType={messageModel.type}
                    messageDescription={messageModel.disciption}
                    clicked={modalDismissHandler}
                />
            </Fragment>
        </div>
    );
}